import { MatSnackBar } from '@angular/material/snack-bar';

import { Toast } from '@helper/toast';
import { Constants } from '@helper/constants';

export class InventoryCheck {
  static showExceededToast(toast: MatSnackBar, value: number, max: number): void {
    const defaultMax = Constants.MAX_CART_ITEM_COUNT;
    if (!max || (value <= defaultMax && value > max)) {
      Toast.open(toast, $localize`商品庫存不足`);
    }
    if (value > defaultMax) {
      Toast.open(toast, $localize`已超過可購買數量`);
    }
  }
}
